import { productsApi } from "@dashboard/products/api";
import { Build } from "@dashboard/products/types";

export const countDownloads = (build: Build, artifactIds: number[]) =>
    productsApi.util.updateQueryData("fetchProductBuilds", build.productId, (builds) => {
        builds
            .find((item) => item.buildId === build.buildId)
            ?.artifacts.filter((artifact) => artifactIds.includes(artifact.id))
            .forEach((artifact) => {
                artifact.downloads += 1;
            });
    });
